import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/index';
import { User } from '../../core/model/user.model';
import { AuthState, STORE_FEATURE_KEY_AUTHENTICATE } from './authentication.reducer';

const authenticateSelector = (appState: any) => appState[STORE_FEATURE_KEY_AUTHENTICATE];
const currentUserSelector = (appState: any) => appState[STORE_FEATURE_KEY_AUTHENTICATE].user;
const isAdminSelector = (appState: any) => appState[STORE_FEATURE_KEY_AUTHENTICATE].isAdmin;
const userCustomFieldsSelector = (appState: any) => appState[STORE_FEATURE_KEY_AUTHENTICATE].userCustomFields;
const retryRequestsSelector = (appState: any) => appState[STORE_FEATURE_KEY_AUTHENTICATE].retryRequests;
const portalVersionSelector = (appState: any) => appState[STORE_FEATURE_KEY_AUTHENTICATE].portalVersion;
const viewSessionIdSelector = (appState: any) => appState[STORE_FEATURE_KEY_AUTHENTICATE].viewSessionId;
const isAuthenticatedFromAdminSelector = (appState: any) => appState[STORE_FEATURE_KEY_AUTHENTICATE].isAuthenticatedFromAdmin;
const isPortalVersionChangedSelector = (appState: any) => appState[STORE_FEATURE_KEY_AUTHENTICATE].isPortalVersionChanged;
const isWebsocketSessionActiveSelector = (appState: any) => appState[STORE_FEATURE_KEY_AUTHENTICATE].isWebsocketSessionActive;

@Injectable({ providedIn: 'root' })
export class AuthenticationSelectors {
    constructor(private store: Store<any>) {
    }

    selectAuthenticate(): Observable<AuthState> {
        return this.store.pipe(select(authenticateSelector));
    }

    selectCurrentUser(): Observable<User> {
        return this.store.pipe(select(currentUserSelector));
    }

    selectIsAdmin(): Observable<boolean> {
        return this.store.pipe(select(isAdminSelector));
    }

    selectUserCustomFields(): Observable<any> {
        return this.store.pipe(select(userCustomFieldsSelector));
    }

    selectRetryRequests(): Observable<boolean> {
        return this.store.pipe(select(retryRequestsSelector));
    }

    selectPortalVersion(): Observable<string> {
        return this.store.pipe(select(portalVersionSelector));
    }

    selectViewSessionId(): Observable<string> {
        return this.store.pipe(select(viewSessionIdSelector));
    }

    selectIsAuthenticatedFromAdmin(): Observable<boolean> {
        return this.store.pipe(select(isAuthenticatedFromAdminSelector));
    }

    selectIsPortalVersionChangedSelector(): Observable<boolean> {
        return this.store.pipe(select(isPortalVersionChangedSelector));
    }

    selectIsWebsocketSessionActiveSelector(): Observable<boolean> {
        return this.store.pipe(select(isWebsocketSessionActiveSelector));
    }
}
